'use client';

import {chakra} from '@chakra-ui/react';

// Create styled versions of common HTML elements needed in React 19
export const ChakraA = chakra(`a`);
export const ChakraAside = chakra(`aside`);
export const ChakraArticle = chakra(`article`);
export const ChakraB = chakra(`b`);
export const ChakraButton = chakra(`button`);
export const ChakraDiv = chakra(`div`);
export const ChakraFooter = chakra(`footer`);
export const ChakraForm = chakra(`form`);
export const ChakraH1 = chakra(`h1`);
export const ChakraH2 = chakra(`h2`);
export const ChakraH3 = chakra(`h3`);
export const ChakraH4 = chakra(`h4`);
export const ChakraH5 = chakra(`h5`);
export const ChakraH6 = chakra(`h6`);
export const ChakraHeader = chakra(`header`);
export const ChakraI = chakra(`i`);
export const ChakraImg = chakra(`img`);
export const ChakraInput = chakra(`input`);
export const ChakraLabel = chakra(`label`);
export const ChakraLi = chakra(`li`);
export const ChakraMain = chakra(`main`);
export const ChakraMarker = chakra(`marker`);
export const ChakraMenu = chakra(`menu`);
export const ChakraNav = chakra(`nav`);
export const ChakraOl = chakra(`ol`);
export const ChakraOption = chakra(`option`);
export const ChakraP = chakra(`p`);
export const ChakraPath = chakra(`path`);
export const ChakraPre = chakra(`pre`);
export const ChakraSection = chakra(`section`);
export const ChakraSelect = chakra(`select`);
export const ChakraSpan = chakra(`span`);
export const ChakraTable = chakra(`table`);
export const ChakraTbody = chakra(`tbody`);
export const ChakraTd = chakra(`td`);
export const ChakraTextarea = chakra(`textarea`);
export const ChakraTh = chakra(`th`);
export const ChakraThead = chakra(`thead`);
export const ChakraTime = chakra(`time`);
export const ChakraTr = chakra(`tr`);
export const ChakraUl = chakra(`ul`);

// Create a compatibility wrapper with HTML elements for easier migration
// This is a temporary solution and should be replaced with the proper styled components
export const chakraCompat = {
  a: ChakraA,
  aside: ChakraAside,
  article: ChakraArticle,
  b: ChakraB,
  button: ChakraButton,
  div: ChakraDiv,
  footer: ChakraFooter,
  form: ChakraForm,
  h1: ChakraH1,
  h2: ChakraH2,
  h3: ChakraH3,
  h4: ChakraH4,
  h5: ChakraH5,
  h6: ChakraH6,
  header: ChakraHeader,
  img: ChakraImg,
  input: ChakraInput,
  label: ChakraLabel,
  li: ChakraLi,
  main: ChakraMain,
  nav: ChakraNav,
  ol: ChakraOl,
  option: ChakraOption,
  p: ChakraP,
  section: ChakraSection,
  select: ChakraSelect,
  span: ChakraSpan,
  table: ChakraTable,
  tbody: ChakraTbody,
  td: ChakraTd,
  textarea: ChakraTextarea,
  th: ChakraTh,
  thead: ChakraThead,
  time: ChakraTime,
  tr: ChakraTr,
  ul: ChakraUl,
};
